import { render, staticRenderFns } from "./ClinicalNotesIcon.vue?vue&type=template&id=530fcbe3&scoped=true&"
import script from "./ClinicalNotesIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ClinicalNotesIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530fcbe3",
  null
  
)

export default component.exports